/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：49__part-0
 */

import { le, de, fe, me, ge, _e, ve } from "../../../../unrestored/shared/1571/2636/49__part-1"
import { Se, Ae, je, Ne, Re } from "../../../../unrestored/shared/1571/2636/49__part-2"
import { Me, Le, Pe, Be, Fe, Ge } from "../../../../unrestored/shared/1571/2636/49__part-3"
import { Ue, Ve, ze, Ye, qe, Xe, Qe, Je, $e, et } from "../../../../unrestored/shared/1571/2636/49__part-4"
import { rt, ot, it, st, lt, ut, pt, ft } from "../../../../unrestored/shared/1571/2636/49__part-5"
import { _t, bt, yt, Et, Ot, Tt, At, It, jt, Nt, xt, Mt, Lt, Pt, Bt, Gt, Ut, Ht } from "../../../../unrestored/shared/1571/2636/49__part-6"
import { Kt, Xt, Qt } from "../../../../unrestored/shared/1571/2636/49__part-7"
import { Jt, rn, an, sn } from "../../../../unrestored/shared/1571/2636/49__part-8"
import * as GlobalWidgetServerOp from "./global-widget/server-op"
export * as extensionWidget from "./extension-widget"
import { yn, En, On, wn, Cn, Tn, Sn, oTHelper } from "."
var r = {}
Object.defineProperty(r, "addWidgetOp", {
  get: function () {
    return le
  }
})
Object.defineProperty(r, "addInvisibleWidgetOp", {
  get: function () {
    return de
  }
})
Object.defineProperty(r, "addBrushAndActorWidgetOp", {
  get: function () {
    return fe
  }
})
Object.defineProperty(r, "deleteWidgetOp", {
  get: function () {
    return me
  }
})
Object.defineProperty(r, "deleteInvisibleWidgetOp", {
  get: function () {
    return ge
  }
})
Object.defineProperty(r, "replaceWidgetAttributeOp", {
  get: function () {
    return _e
  }
})
Object.defineProperty(r, "moveWidget", {
  get: function () {
    return ve
  }
})
var o = {}
Object.defineProperty(o, "pick", {
  get: function () {
    return Se
  }
})
Object.defineProperty(o, "drop", {
  get: function () {
    return Ae
  }
})
export var widget = {}
Object.defineProperty(widget, "clientOp", {
  get: function () {
    return r
  }
})
Object.defineProperty(widget, "serverOp", {
  get: function () {
    return o
  }
})
var a = {}
Object.defineProperty(a, "changeProjectProperty", {
  get: function () {
    return je
  }
})
var s = {}
Object.defineProperty(s, "pick", {
  get: function () {
    return Ne
  }
})
Object.defineProperty(s, "drop", {
  get: function () {
    return Re
  }
})
export var projectOt = {}
Object.defineProperty(projectOt, "clientOp", {
  get: function () {
    return a
  }
})
Object.defineProperty(projectOt, "serverOp", {
  get: function () {
    return s
  }
})
var l = {}
Object.defineProperty(l, "addScreen", {
  get: function () {
    return Me
  }
})
Object.defineProperty(l, "removeScreen", {
  get: function () {
    return Le
  }
})
Object.defineProperty(l, "moveScreen", {
  get: function () {
    return Pe
  }
})
Object.defineProperty(l, "updateScreenStyle", {
  get: function () {
    return Be
  }
})
var u = {}
Object.defineProperty(u, "pick", {
  get: function () {
    return Fe
  }
})
Object.defineProperty(u, "drop", {
  get: function () {
    return Ge
  }
})
export var screen = {}
Object.defineProperty(screen, "clientOp", {
  get: function () {
    return l
  }
})
Object.defineProperty(screen, "serverOp", {
  get: function () {
    return u
  }
})
var p = {}
Object.defineProperty(p, "add", {
  get: function () {
    return Ue
  }
})
Object.defineProperty(p, "remove", {
  get: function () {
    return Ve
  }
})
Object.defineProperty(p, "replaceImageFileId", {
  get: function () {
    return ze
  }
})
Object.defineProperty(p, "replaceImageFileCdnUrl", {
  get: function () {
    return Ye
  }
})
var f = {}
Object.defineProperty(f, "pick", {
  get: function () {
    return qe
  }
})
Object.defineProperty(f, "drop", {
  get: function () {
    return Xe
  }
})
export var imageFileList = {}
Object.defineProperty(imageFileList, "clientOp", {
  get: function () {
    return p
  }
})
Object.defineProperty(imageFileList, "serverOp", {
  get: function () {
    return f
  }
})
var m = {}
Object.defineProperty(m, "add", {
  get: function () {
    return Qe
  }
})
Object.defineProperty(m, "remove", {
  get: function () {
    return Je
  }
})
Object.defineProperty(m, "replaceSoundName", {
  get: function () {
    return $e
  }
})
Object.defineProperty(m, "replaceSoundFileCdnUrl", {
  get: function () {
    return et
  }
})
var g = {}
Object.defineProperty(g, "pick", {
  get: function () {
    return rt
  }
})
Object.defineProperty(g, "drop", {
  get: function () {
    return ot
  }
})
export var soundFileList = {}
Object.defineProperty(soundFileList, "clientOp", {
  get: function () {
    return m
  }
})
Object.defineProperty(soundFileList, "serverOp", {
  get: function () {
    return g
  }
})
var v = {}
Object.defineProperty(v, "add", {
  get: function () {
    return it
  }
})
Object.defineProperty(v, "remove", {
  get: function () {
    return st
  }
})
Object.defineProperty(v, "replaceIconName", {
  get: function () {
    return lt
  }
})
Object.defineProperty(v, "replaceIconFileCdnUrl", {
  get: function () {
    return ut
  }
})
var b = {}
Object.defineProperty(b, "pick", {
  get: function () {
    return pt
  }
})
Object.defineProperty(b, "drop", {
  get: function () {
    return ft
  }
})
export var iconFileList = {}
Object.defineProperty(iconFileList, "clientOp", {
  get: function () {
    return v
  }
})
Object.defineProperty(iconFileList, "serverOp", {
  get: function () {
    return b
  }
})
var E = {}
Object.defineProperty(E, "add", {
  get: function () {
    return _t
  }
})
Object.defineProperty(E, "remove", {
  get: function () {
    return bt
  }
})
Object.defineProperty(E, "update", {
  get: function () {
    return yt
  }
})
var O = {}
Object.defineProperty(O, "pick", {
  get: function () {
    return Et
  }
})
Object.defineProperty(O, "drop", {
  get: function () {
    return Ot
  }
})
export var primitiveVariables = {}
Object.defineProperty(primitiveVariables, "clientOp", {
  get: function () {
    return E
  }
})
Object.defineProperty(primitiveVariables, "serverOp", {
  get: function () {
    return O
  }
})
var C = {}
Object.defineProperty(C, "add", {
  get: function () {
    return Tt
  }
})
Object.defineProperty(C, "remove", {
  get: function () {
    return At
  }
})
Object.defineProperty(C, "updateProperty", {
  get: function () {
    return It
  }
})
var T = {}
Object.defineProperty(T, "pick", {
  get: function () {
    return jt
  }
})
Object.defineProperty(T, "drop", {
  get: function () {
    return Nt
  }
})
export var arrayVariables = {}
Object.defineProperty(arrayVariables, "clientOp", {
  get: function () {
    return C
  }
})
Object.defineProperty(arrayVariables, "serverOp", {
  get: function () {
    return T
  }
})
var A = {}
Object.defineProperty(A, "add", {
  get: function () {
    return xt
  }
})
Object.defineProperty(A, "remove", {
  get: function () {
    return Mt
  }
})
Object.defineProperty(A, "updateProperty", {
  get: function () {
    return Lt
  }
})
var I = {}
Object.defineProperty(I, "pick", {
  get: function () {
    return Pt
  }
})
Object.defineProperty(I, "drop", {
  get: function () {
    return Bt
  }
})
export var objectVariables = {}
Object.defineProperty(objectVariables, "clientOp", {
  get: function () {
    return A
  }
})
Object.defineProperty(objectVariables, "serverOp", {
  get: function () {
    return I
  }
})
var N = {}
Object.defineProperty(N, "add", {
  get: function () {
    return Gt
  }
})
var R = {}
Object.defineProperty(R, "pick", {
  get: function () {
    return Ut
  }
})
Object.defineProperty(R, "drop", {
  get: function () {
    return Ht
  }
})
export var broadcasts = {}
Object.defineProperty(broadcasts, "clientOp", {
  get: function () {
    return N
  }
})
Object.defineProperty(broadcasts, "serverOp", {
  get: function () {
    return R
  }
})
var x = {}
Object.defineProperty(x, "focusItem", {
  get: function () {
    return Kt
  }
})
Object.defineProperty(x, "userColors", {
  get: function () {
    return Xt
  }
})
Object.defineProperty(x, "cloudDb", {
  get: function () {
    return Qt
  }
})
export var customEvent = {}
Object.defineProperty(customEvent, "emit", {
  get: function () {
    return x
  }
})
Object.defineProperty(customEvent, "accept", {
  get: function () {
    return Jt
  }
})
var M = {}
Object.defineProperty(M, "add", {
  get: function () {
    return rn
  }
})
Object.defineProperty(M, "del", {
  get: function () {
    return an
  }
})
Object.defineProperty(M, "replaceWidgetAttributeOp", {
  get: function () {
    return sn
  }
})
export var globalWidget = {}
Object.defineProperty(globalWidget, "clientOp", {
  get: function () {
    return M
  }
})
Object.defineProperty(globalWidget, "serverOp", {
  get: function () {
    return GlobalWidgetServerOp
  }
})
var W = {}
Object.defineProperty(W, "updateCloudDictKeys", {
  get: function () {
    return yn
  }
})
Object.defineProperty(W, "updateCloudTableColumns", {
  get: function () {
    return En
  }
})
Object.defineProperty(W, "updateCloudTableData", {
  get: function () {
    return On
  }
})
Object.defineProperty(W, "updateCloudDictList", {
  get: function () {
    return wn
  }
})
Object.defineProperty(W, "updateCloudTableList", {
  get: function () {
    return Cn
  }
})
var U = {}
Object.defineProperty(U, "pick", {
  get: function () {
    return Tn
  }
})
Object.defineProperty(U, "drop", {
  get: function () {
    return Sn
  }
})
export var cloudSpace = {}
Object.defineProperty(cloudSpace, "clientOp", {
  get: function () {
    return W
  }
})
Object.defineProperty(cloudSpace, "serverOp", {
  get: function () {
    return U
  }
})
export var focus = {}
Object.defineProperty(focus, "oTHelper", {
  get: function () {
    return oTHelper
  }
})
